import Flex from "@/shared/components/common/Flex";
import { cn } from "@/shared/libs/commonUtils";
import type { ReactNode } from "react";

interface HotelCardPanelProps {
  isOpen: boolean;
  children: ReactNode;
}

export default function HotelCardPanel({
  isOpen,
  children,
}: HotelCardPanelProps) {
  return (
    <Flex
      className={cn(
        "w-full transition-all duration-200 ease-in-out overflow-hidden",
        isOpen ? "h-60" : "h-0",
      )}
    >
      {children}
    </Flex>
  );
}
